import { Outlet, useLocation } from 'react-router-dom';
// import Sidebar from '../../../../component/layout/sidebar/Sidebar';
import styles from './MainLayout.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import ErrorMobile from '../../../../assets/image/error-mobile.svg';
import SidebarNEW from 'component/layout/sidebar-new/Sidebar';
import WorkFlowChat from 'pages/authenticated/work-flow/components/work-flow-chat/WorkFlowChat';
import { useEffect, useState } from 'react';
// add the path that it's page needs to remove the padding from the page
const secondaryPaths = [/^\/chat-console\/?$/, /^\/chat-console\/[^/]+\/?$/];

const MainLayout = ({ isRestrictedUser }) => {
  const { isTablet } = useResponsive();
  const location = useLocation();
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;
  const [selectedBot, setSelectedBot] = useState(
    JSON.parse(localStorage.getItem('selectedBot')),
  );
  // there is 2 variant for the page with padding and without padding
  const pageStyle = secondaryPaths.some((re) => re.test(location.pathname))
    ? 'primary'
    : 'default';

  const pageClassname = `${styles['page-container']} ${styles[pageStyle]} layout-default`;
  const sidebarType = pageStyle === 'primary';

  useEffect(() => {
    setSelectedBot(JSON.parse(localStorage.getItem('selectedBot')));
  }, [localStorage.getItem('selectedBot')]);
  return (
    <>
      <div
        className={styles['main-layout']}
        style={{ backgroundColor: 'white', color: page_TextColor }}
      >
        <div>
          <SidebarNEW sidebarType={sidebarType} isTablet={isTablet} />
        </div>

        <div className={styles['layout']}>
          <div className={pageClassname}>
            <Outlet />
          </div>
        </div>
      </div>

      {'/dashboard' !== location.pathname &&
        '/users' !== location.pathname &&
        '/chat-console' !== location.pathname &&
        '/profile' !== location.pathname && (
          <WorkFlowChat botId={selectedBot?.botId} ChatSource={1} />
        )}
    </>
  );
};

export default MainLayout;
